import React from "react";
import styled from "styled-components";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";

/* Page Wrapper */

const RefundSection = styled.section`
  padding: 120px 20px 80px;
  background: #ffffff;
`;

/* Content Wrapper */

const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
`;

/* Title */

const Title = styled.h1`
  font-size: 36px;
  margin-bottom: 20px;
`;

/* Section Title */

const SubTitle = styled.h2`
  font-size: 22px;
  margin-top: 35px;
  margin-bottom: 10px;
`;

/* Paragraph */

const Text = styled.p`
  line-height: 1.7;
  margin-bottom: 12px;
  color: #555;
`;

/* List */

const List = styled.ul`
  margin-left: 20px;
`;

const ListItem = styled.li`
  margin-bottom: 8px;
`;

const RefundPolicy = () => {
  return (
    <>
      <TopNavbar />

      <RefundSection>
        <Wrapper>

          <Title>Refund & Cancellation Policy</Title>

          <Text>
            At EBK Thangamaligai, customer satisfaction is extremely important
            to us. This Refund and Cancellation Policy explains the conditions
            under which orders may be cancelled and refunds may be processed.
          </Text>

          <SubTitle>1. Order Cancellation</SubTitle>

          <Text>
            If the item you have ordered has been shipped but has not yet been
            delivered to you, you may still cancel the order online or by
            contacting our customer support team.
          </Text>

          <Text>
            Once the order is cancelled and the product is returned to us by
            the courier service, the refund will be processed.
          </Text>

          <SubTitle>2. Refund Processing</SubTitle>

          <Text>
            After the returned item is received and verified by our team,
            EBK Thangamaligai will initiate the refund process.
          </Text>

          <Text>
            Refunds are generally processed within <strong>7 working days</strong>
            after the returned item is received at our facility.
          </Text>

          <SubTitle>3. Credit Card Payments</SubTitle>

          <Text>
            If the payment was made using a credit card, the refund amount will
            be credited back to the same credit card account used during the
            purchase.
          </Text>

          <Text>
            The time required for the amount to appear in your account depends
            on the bank or credit card provider and may vary according to their
            processing timelines.
          </Text>

          <SubTitle>4. Bank Transfer / Wire Transfer</SubTitle>

          <Text>
            If payment was made through bank transfer, the refund amount will
            be deposited into the customer's bank account.
          </Text>

          <Text>
            The transfer will typically be completed within
            <strong> seven (7) business days </strong>
            after the refund request has been approved.
          </Text>

          <SubTitle>5. Conditions for Refund</SubTitle>

          <Text>
            Refunds will be processed only under the following conditions:
          </Text>

          <List>
            <ListItem>The item must be returned in its original condition.</ListItem>
            <ListItem>The product must not be damaged or altered.</ListItem>
            <ListItem>Original packaging and invoice must be included.</ListItem>
            <ListItem>The return request must be made within the allowed time period.</ListItem>
          </List>

          <SubTitle>6. Non-Refundable Situations</SubTitle>

          <Text>
            Refunds may not be applicable in the following situations:
          </Text>

          <List>
            <ListItem>Customized or special-order jewellery items.</ListItem>
            <ListItem>Products damaged due to misuse or mishandling.</ListItem>
            <ListItem>Products returned without original packaging.</ListItem>
            <ListItem>Requests made after the permitted return window.</ListItem>
          </List>

          <SubTitle>7. Contact Us</SubTitle>

          <Text>
            If you have any questions about our Refund & Cancellation Policy,
            please contact us through our website or reach us at:
          </Text>

          <Text>
            <strong>Email:</strong> support@ebkthangamaligai.com
          </Text>

        </Wrapper>
      </RefundSection>

      <Footer />
    </>
  );
};

export default RefundPolicy;